import { units, writingMode } from './subtitles.constants';
import { getFullContainerWidth, getFullContainerHeight } from './subtitles.style';

// See https://www.w3.org/TR/2018/REC-ttml1-20181108/#style-attribute-displayAlign
export const displayAlignToFlex = displayAlign => {
  switch (displayAlign) {
    case 'before':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'after':
      return 'flex-end';
    default:
      return 'flex-end';
  }
};

// See https://www.w3.org/TR/2018/REC-ttml1-20181108/#style-attribute-textAlign
export const textAlignToFlex = textAlign => {
  switch (textAlign) {
    case 'left':
    case 'start':
      return 'flex-start';
    case 'right':
    case 'end':
      return 'flex-end';
    case 'center':
      return 'center';
    default:
      return 'flex-start';
  }
};

export const getDimensionsByRegion = (cue, screenSize) => {
  const { region } = cue;

  const supportableUnits = [units.PX, units.PERCENTAGE];
  const containerWidth = getFullContainerWidth(screenSize);
  const containerHeight = getFullContainerHeight(screenSize);
  const usePercentage = region.widthUnits === units.PERCENTAGE;

  if (supportableUnits.includes(region.widthUnits) && supportableUnits.includes(region.heightUnits)) {
    return {
      w: usePercentage ? containerWidth * (region.width / 100) : region.width,
      h: usePercentage ? containerHeight * (region.height / 100) : region.height,
      x: Math.round(containerWidth * (region.viewportAnchorX / 100)),
      y: Math.round(containerHeight * (region.viewportAnchorY / 100)),
      flex: {
        justifyContent: displayAlignToFlex(cue.displayAlign),
      },
    };
  }

  return {};
};

export const getDimensionsBySize = (size, cueWritingMode, screenSize) => {
  const containerWidth = getFullContainerWidth(screenSize);
  const containerHeight = getFullContainerHeight(screenSize);

  if (cueWritingMode === writingMode.HORIZONTAL_TOP_TO_BOTTOM) {
    return { w: containerWidth * (size / 100) };
  }

  return { h: containerHeight * (size / 100) };
};

export const getLengthValueInfo = lengthValue => {
  // eslint-disable-next-line prefer-regex-literals
  const matches = new RegExp(/(\d*\.?\d+)([a-z]+|%+)/).exec(lengthValue);
  if (!matches) {
    return null;
  }

  return { value: Number(matches[1]), unit: matches[2] };
};

export const getAbsoluteLengthInPixels = (value, cue, containerHeight) =>
  (containerHeight * value) / cue.cellResolution.rows;

export const convertLengthValue = (lengthValue, cue, screenSize) => {
  const lengthValueInfo = getLengthValueInfo(lengthValue);
  if (!lengthValueInfo) {
    return lengthValue;
  }

  const fullContainerHeight = getFullContainerHeight(screenSize);
  const { unit, value } = lengthValueInfo;

  switch (unit) {
    case '%':
      return getAbsoluteLengthInPixels(value / 100, cue, fullContainerHeight);
    case 'c':
      return getAbsoluteLengthInPixels(value, cue, fullContainerHeight);
    default:
      return lengthValue;
  }
};

export const parseColor = (hex, fallback = 0x00000000) => {
  const result = parseInt(
    hex.length === 9 ? `0x${hex.substring(7)}${hex.substring(1, 7)}` : hex.replace('#', '0x'),
    16,
  );

  return Number.isFinite(result) ? result : fallback;
};
